module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playDown",
    class: {
      playDown2: !_vm.tgNum
    }
  }, [_c('dl', {
    on: {
      "click": _vm.showBigPlay
    }
  }, [_c('dt', [_c('img', {
    attrs: {
      "src": _vm.imgUrl,
      "onerror": "javascript:this.src=\"http://www.xi-g.com/dist/logo.png\""
    }
  })]), _vm._v(" "), _c('dd', [_c('h3', [_vm._v(_vm._s(_vm.songName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.singerName))])])]), _vm._v(" "), _c('div', {
    staticClass: "play",
    class: {
      'pause': _vm.isplay
    },
    on: {
      "click": _vm.playorp
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.nextSong
    }
  }), _vm._v(" "), _c('audio', {
    staticClass: "song",
    attrs: {
      "id": "audioPlay",
      "src": _vm.songUrl,
      "autoplay": ""
    },
    on: {
      "ended": _vm.nextSong,
      "timeupdate": _vm.change
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "showHide",
    class: {
      showHide2: _vm.tgNum
    },
    on: {
      "click": function($event) {
        _vm.tgNum = !_vm.tgNum
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/to_top.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ecc69e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/playDown.vue
// module id = 99
// module chunks = 0